import ultravioletPrinting from "./templates/ultraviolet-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `
        <p>
          Идеальный подарок для сотрудников и партнёров. 
          Корпус имеет покрытие soft-touch. 
          Большая площадь поверхности аккумулятора представляет широкие возможности для персонализации.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${ultravioletPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
